/**
 * Character illustration name registry — single source of truth for all
 * allowed character illustration names. Names are kebab-case and sorted;
 * the mapping back to Figma nodes lives in figma-source.json alongside this file.
 */

export const characterIllustrationNames = [
  'ai-conversation',
  'being-active',
  'breathalyser',
  'care-team-at-work-emotional',
  'care-team-at-work-functional',
  'carrying-boat',
  'character-a',
  'character-b',
  'character-c',
  'character-d',
  'cyclist',
  'exploring',
  'family',
  'feeling-support',
  'fireworks',
  'friends-celebration',
  'getting-started-beach',
  'getting-started-boat',
  'growth-lg',
  'growth-sm',
  'guidance',
  'helping-lg',
  'helping-sm',
  'high-five',
  'home-delivery',
  'how-to-use-it',
  'human-emotions',
  'ice-cream-fail',
  'idea',
  'juggle',
  'living-room',
  'looking-ahead-lg',
  'looking-ahead-sm',
  'man-thumbs-up',
  'man-waving',
  'map',
  'meditation',
  'member-taking-medication-alcohol',
  'member-taking-medication-tobacco',
  'member-taking-urine-test',
  'member-using-app',
  'member-using-app-blue',
  'mindfulness-activities-relaxing',
  'nature-landscape',
  'nature-relaxation',
  'negative-thoughts',
  'notifications',
  'office-space',
  'overcoming-obstacles',
  'peaceful-butterfly',
  'picking-fruit',
  'progress',
  'progress-wide',
  'reading-book',
  'reading-card',
  'reading-map',
  'relapse',
  'relationship-interaction',
  'relaxing-together',
  'rowing',
  'sailing-together-lg',
  'sailing-together-sm',
  'save-money',
  'setting-goals-archery',
  'setting-goals-calendar',
  'skipping',
  'success',
  'thinking',
  'waking-up',
  'walking',
  'walking-bridge-lg',
  'walking-bridge-sm',
  'watering-plant',
  'welcome',
  'well-done',
  'woman-thumbs-up',
  'woman-thumbs-up-2',
] as const;

export type CharacterIllustrationName = (typeof characterIllustrationNames)[number];

export const characterIllustrationNameSet: ReadonlySet<string> = new Set(
  characterIllustrationNames,
);
